<template>
  <div>
     <div class="title">
        <span class="link">服务管理 ></span> <span class="curLink">咨询服务 </span>   
     </div>
     <div class="content">
        <div class="pageList">
        <div>
          <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline">
            <el-form-item label="服务类型" prop="useScenarios">
              <el-select v-model="formInline.useScenarios" placeholder="请选择服务类型">
                <el-option label="全部" value=""></el-option>
                <el-option label="工业互联网战略咨询服务" value="工业互联网战略咨询服务"></el-option>
                <el-option label="软硬件集成服务" value="软硬件集成服务"></el-option>
                <el-option label="实训基地及培训服务" value="实训基地及培训服务"></el-option>
                <el-option label="开放API能力" value="开放API能力"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务状态" prop="replyStatus">
              <el-select v-model="formInline.replyStatus" placeholder="请选择服务状态">
                <el-option label="全部" value=""></el-option>
                <el-option label="未回复" value="0"></el-option>
                <el-option label="已回复" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="float: right;">
              <el-button @click="onReset">重置</el-button>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
       </div>
        <div class="list">
          <template v-if="list.length">
            <div class="listItem" v-for="item in list" :key="item.id">
            <div class="tit">{{item.useScenarios}}</div>
            <div class="flexItem flexItem2">
              <div><span class="label">申请企业</span><span class="value">{{item.companyName}}</span></div>
              <div><span class="label">联系电话</span><span class="value">{{item.phone}}</span></div>
              <div><span class="label">申请人</span><span class="value">{{item.name}}</span></div>
            </div>
            <div class="flexItem flexItem2">
              <div><span class="label">申请时间</span><span class="value">{{item.createTime}}</span></div>
              <div v-if="item.replyTime"><span class="label">回复时间</span><span class="value">{{item.replyTime}}</span></div>
            </div>
            <div class="flexItem"><span class="label">具体需求</span>{{item.demand}}</div>
            <div class="flexItem" v-if="item.reply"><span class="label">后台回复</span>{{item.reply}}</div>
          </div>
          </template>
          <template v-else>
            <Nodata />
          </template>
          
        </div>
        <div class="pageBox">
           <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next"
              :total="total">
            </el-pagination>
        </div>
       </div>
     </div>
  </div>
   
</template>
<script>
import {
    fetchServeList
  } from '@/api/api'
import Nodata from '@/components/noData.vue'
export default {
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      list: [],
      formInline: {
        useScenarios: '',
        replyStatus: '',
      },
    }
  },
  components:{
      Nodata
  },
  created() {
    this.getList()
  },
  methods: {
    onReset() {
      this.$refs.formInline.resetFields()
    },
    onSubmit() {
      this.pageNum = 1
      this.pageSize = 10
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    getList() {
      let params = {
        ...this.formInline,
        pageNum: this.pageNum-1,
        pageSize: this.pageSize
      }
      fetchServeList(params).then(res => {
        this.list = res.data.content
        this.total = Number(res.data.totalElements)
      })
    }
  }
}
</script>

<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }
  .curLink{
    cursor: pointer;
  }
  .link{
    color: rgba(144, 157, 177, 1);
  }
  .content {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .pageList {
    width: 100%;
    height: calc(100vh - 180px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;
  }
  .listItem{
    padding: 10px 0;
    border-bottom: 1px solid #E8EBF4;
  }
  .listItem:last-child{
    /* border: none; */
  }
  .listItem .tit{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    padding-top: 10px;
  }
  .listItem .label{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    /* padding-right: 24px; */
    display: inline-block;
    min-width: 80px;
  }
  .listItem .value{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
  }
  .flexItem{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-top: 15px;
  }
  .flexItem2 > div{
    width: 30%;
  }

  .list{
    height: calc(100vh - 330px);
    overflow-y: scroll;
    /* border: 1px solid #f00; */
  }
  .list::-webkit-scrollbar { width: 0 !important }
  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
</style>


// WEBPACK FOOTER //
// src/views/console/ServiceAdv.vue